<template>
  <div class="maintenancePage">
    <div class="wrap">
      <img src="../assets/images/maintenancePageImg.png">
      <div class="content">
        <p class="title">为了配合新CRM系统上线，ECP系统停机维护，期间ECP所有功能无法使用，给各位带来不便敬请谅解</p>
        <div class="time">维护时间：2022-02-25 20:00～2022-02-28 00:00</div>
        <div class="prompt">
          <span>如需帮助请联系</span>
          <span>锐捷网络-信息资源部-史孟艳</span>
        </div>
        <div class="contacts">
          <div class="phone">
            <img src="@/assets/images/phonIcon.png">
            <span>15910548127</span>
          </div>
          <div class="email">
            <img src="@/assets/images/emilyIcon.png">
            <span>shimengyan@ruijie.com.cn</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
};
</script>

<style lang="scss" scoped>
.maintenancePage{
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #FFFFFF;
  >.wrap{
    width: 1000px;
    margin: 0 auto;
    position: relative;
    top: 50%;
    transform: translateY(-58%);
    text-align: center;
    >img{
      width: 500px;
    }
    >.content{
      color: #424C57;
      position: relative;
      top: -20px;
      >.title{
        font-size: 20px;
        line-height: 22px;
      }
      >.time{
        font-weight: bold;
        font-size: 20px;
        margin: 20px 0 50px;
      }
      >.prompt{
        text-align: center;
        font-size: 20px;
        margin-bottom: 10px;
        &>span:first-child{
          margin-right: 40px;
        }
      }
      >.contacts{
        text-align: center;
        margin-bottom: 40px;
        display: flex;
        justify-content: center;
        >div{
          font-size: 18px;
          >img{
            width: 18px;
            margin-right: 6px;
            vertical-align: middle;
          }
          >span{
            display: inline-block;
            vertical-align: middle;
          }
        }
        >.phone{
          margin-right: 50px;
        }
        >.email{
        }
      }
    }
  }
}
</style>
